export const meetingType = {
  lss: "lss",
  intake: "intake",
  intakeCancel: "intakeCancel",
  cmn: "cmn",
} as const;

export type MeetingType = (typeof meetingType)[keyof typeof meetingType];

export const REQUIRED_VALIDATION_MESSAGE = "This is a required field";

export const FUNNEL_PATH = "/v2/funnel";
